// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"GT-z","categoryName":"HT-z","categoryNameSearchHeader":"IT-z","categoryContent":"JT-z","bottomAligned":"KT-z","image":"LT-z","imageNoBackground":"MT-z"};